import {Component, Input} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {UserAttribute} from "../../../../../model/user-attribute";

@Component({
  selector: 'attribute-enum',
  templateUrl: './attribute-enum.component.html',
  styleUrls: ['./attribute-enum.component.scss']
})
export class AttributeEnumComponent {
  @Input() attribute: UserAttribute;
  @Input() form: FormGroup;
  @Input() disabled: boolean
  @Input() readonly: boolean
  value: string;
}
